'use client';
import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

const FAQS = [
  {
    q: 'Могу ли я отменить подписку в любой момент?',
    a: 'Да. Ты можешь отменить подписку в любой момент в настройках аккаунта. Доступ сохраняется до конца оплаченного периода. Никаких штрафов и вопросов.',
  },
  {
    q: 'Что такое живые сессии и как часто они проходят?',
    a: 'Живые сессии — это встречи в прямом эфире. Медитации, разборы тем, ответы на вопросы. Проходят каждую неделю, обычно в воскресенье. Все записи сохраняются в библиотеке.',
  },
  {
    q: 'Можно ли перейти с одного тарифа на другой?',
    a: 'Да, в любой момент. Переход на более высокий тариф происходит сразу, доступ расширяется немедленно. Переход на более низкий — с начала следующего периода.',
  },
  {
    q: 'Есть ли пробный период?',
    a: 'Мы не делаем "бесплатных пробников" — потому что это меняет отношение к пространству. Но ты можешь начать с Basic ($5) и понять, есть ли отклик. Это лучший способ.',
  },
  {
    q: 'Как происходит оплата?',
    a: 'Оплата через Stripe — карта, Apple Pay, Google Pay. Всё безопасно, данные карты не хранятся на нашем сервере. Автоматическое списание раз в месяц или год.',
  },
  {
    q: 'На каком языке контент?',
    a: 'Весь контент на русском языке. В будущем планируем добавить субтитры на английском и украинском.',
  },
  {
    q: 'Что значит Inner Circle?',
    a: 'Это маленькие группы по 5–10 человек с прямым контактом. Встречи раз в месяц, максимальная близость. Количество мест ограничено — при заполнении тариф временно закрывается.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-28 px-6 lg:px-10 2xl:px-16" style={{ backgroundColor: '#0D0D0D' }}>
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-xs tracking-widest uppercase mb-3" style={{ color: '#7A7470' }}>Вопросы</p>
          <h2
            className="text-3xl font-300 text-white"
            style={{ fontWeight: 300, letterSpacing: '-0.02em' }}
          >
            Частые вопросы
          </h2>
        </div>

        <div className="space-y-2">
          {FAQS?.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl overflow-hidden transition-all duration-300"
              style={{ background: openIndex === i ? '#1A1A1A' : '#141414', border: `1px solid ${openIndex === i ? '#2A2520' : '#1C1C1C'}` }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between p-6 text-left"
              >
                <span className="text-sm font-500 pr-4 leading-snug" style={{ color: '#F0EDE8', fontWeight: 500 }}>
                  {faq?.q}
                </span>
                <div
                  className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-200"
                  style={{ background: openIndex === i ? 'rgba(201,169,110,0.1)' : 'rgba(255,255,255,0.04)', border: `1px solid ${openIndex === i ? '#C9A96E' : 'rgba(255,255,255,0.08)'}` }}
                >
                  {openIndex === i
                    ? <Minus size={13} style={{ color: '#C9A96E' }} />
                    : <Plus size={13} style={{ color: '#7A7470' }} />
                  }
                </div>
              </button>

              {openIndex === i && (
                <div className="px-6 pb-6">
                  <p className="text-sm leading-relaxed" style={{ color: '#7A7470' }}>{faq?.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}